import Reveal from '@/components/base/Reveal';
import { topicGroups } from '@/mocks/home';

export default function TopicIndex() {
  return (
    <section id="topics" className="w-full bg-background-50">
      <div className="mx-auto max-w-[1400px] px-4 py-14 md:px-8 md:py-20">
        <Reveal>
          <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
            <div>
              <p className="flex items-center gap-2 text-sm font-medium text-primary-600">
                <span className="h-px w-8 bg-primary-500" />
                分区索引
              </p>
              <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
                从标签出发，找到你想看的那一类
              </h2>
            </div>
            <p className="max-w-sm text-sm leading-relaxed text-foreground-600">
              所有内容都会被打上类型、方法与热度三类标签，检索时互相交叉即可。
            </p>
          </div>
        </Reveal>

        <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {topicGroups.map((group, i) => (
            <Reveal key={group.name} delay={i * 80} className="h-full">
              <div className="flex h-full flex-col rounded-lg border border-background-200 bg-background-100/50 p-5">
                <h3 className="font-heading text-base font-semibold text-foreground-950">{group.name}</h3>
                <div className="mt-4 flex flex-wrap gap-2">
                  {group.topics.map((topic) => (
                    <a
                      key={topic}
                      href="#featured"
                      className="rounded-md border border-background-200 bg-background-50 px-3 py-1.5 text-sm text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600"
                    >
                      {topic}
                    </a>
                  ))}
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}